import {
  DeactivateReasonCommandInput,
  DeactivateReasonCommandOutput,
} from '@amzn/gbsa-helios-typescript-client';
import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { reasonKeys } from 'src/data/api/helios-service-ts/reason/queries/keys';
import { reasonService } from 'src/data/api/helios-service-ts/reason/service';

/**
 * React Query mutation hook for deactivating a reason.
 * Invalidates the reasons list on success to trigger a re-fetch.
 */
export const useDeactivateReasonMutation = (
  options?: Omit<
    UseMutationOptions<
      DeactivateReasonCommandOutput,
      Error,
      DeactivateReasonCommandInput
    >,
    'mutationFn'
  >,
) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...options,
    mutationFn: (data: DeactivateReasonCommandInput) => reasonService.deactivate(data),
    async onSuccess(data, variables, onMutateResult, context) {
      await queryClient.invalidateQueries({ queryKey: reasonKeys.all });
      await options?.onSuccess?.(data, variables, onMutateResult, context);
    },
  });
};
